<mat-icon color="primary">
	<img [src]="brandLogo" crossorigin="anonymous" [style.height]="logoHeight" />
</mat-icon>